import React from "react"
import types from "prop-types"
import { questionShape } from "utils/propTypeShapes"

const LOST_ANSWERS_MESSAGE = "The answers to these questions will not be transferred "
  + "to the new version of the form."

const LostAnswersOverview = ({ className = "", questions }) => (
  <div className={className}>
    <p className="text-sm text-center text-gray mb-4 w-5/6 mx-auto">
      {LOST_ANSWERS_MESSAGE}
    </p>
    <ul className="m-0 p-4 border border-light-300 rounded max-h-24 lg:max-h-40 overflow-y-auto">
      {
        questions.map(({ prompt, uuid }) => (
          <li className="truncate mb-2 last:mb-0" key={uuid}>
            {prompt}
          </li>
        ))
      }
    </ul>
  </div>
)

LostAnswersOverview.propTypes = {
  className: types.string,
  questions: types.arrayOf(questionShape).isRequired,
}

export default LostAnswersOverview
